import React from "react";

const ElsaDialog = ({ content, sourceData, onClose }) => {
  // Function to add line breaks after specified character count
  const formatContent = (text, charsPerLine = 50) => {
    if (!text) return "";

    // Split the text into words
    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    words.forEach((word) => {
      // Check if adding this word would exceed the line length
      if (
        (currentLine + " " + word).length > charsPerLine &&
        currentLine.length > 0
      ) {
        // If it would, start a new line
        lines.push(currentLine);
        currentLine = word;
      } else {
        // If it wouldn't, add it to the current line
        currentLine =
          currentLine.length === 0 ? word : currentLine + " " + word;
      }
    });

    // Add the last line if it has content
    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    return (
      <>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <div
      className="fixed right-5 bottom-10 w-[400px] rounded-lg p-2 shadow-md z-50 font-manrope"
      style={{
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)",
        transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
        transformOrigin: "bottom",
        backgroundColor: "#E6F7ED",
        fontSize: "14px",
        borderRadius: "4px",
      }}
    >
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-sm text-[#434343]">{formatContent(content)}</div>
        </div>
      </div>
    </div>
  );
};

export default ElsaDialog;
